import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <div className="container max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">
          Politique de Confidentialité
        </h1>

        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
          Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
        </p>

        <div className="bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-500 p-4 mb-8">
          <p className="text-gray-700 dark:text-gray-300">
            Remadia Health s'engage à protéger vos données personnelles conformément au Règlement
            Général sur la Protection des Données (RGPD).
          </p>
        </div>

        {/* Article 1 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 1 - Responsable du traitement
          </h2>
          <div className="space-y-2 text-gray-700 dark:text-gray-300">
            <p>
              <strong>Responsable :</strong> Alcantara Rémi
            </p>
            <p>
              <strong>Email :</strong> contact@remadia.com
            </p>
            <p>
              <strong>Adresse :</strong> 173 rue de Courcelles, 75017 Paris, France
            </p>
          </div>
        </section>

        {/* Article 2 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 2 - Données collectées
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="font-semibold mb-3 text-gray-800 dark:text-gray-200">
                2.1 Données d'identification
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700 dark:text-gray-300">
                <li>Nom et prénom (via Google)</li>
                <li>Adresse email</li>
                <li>Photo de profil (optionnelle)</li>
                <li>Type de profil (non_medical, infirmier, médecin)</li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold mb-3 text-gray-800 dark:text-gray-200">
                2.2 Données d'utilisation
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700 dark:text-gray-300">
                <li>Historique des conversations avec le chatbot IA</li>
                <li>Recherches de médicaments</li>
                <li>Publications sur le forum communautaire</li>
                <li>Statistiques d'utilisation (nombre de recherches, pages visitées)</li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold mb-3 text-gray-800 dark:text-gray-200">
                2.3 Données techniques
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700 dark:text-gray-300">
                <li>Adresse IP</li>
                <li>Type de navigateur et appareil</li>
                <li>
                  Cookies (voir{' '}
                  <Link to="/legal/cookies" className="text-blue-600 dark:text-blue-400 underline">
                    Politique de cookies
                  </Link>
                  )
                </li>
                <li>
                  Géolocalisation (uniquement pour les ressources d'urgence, avec consentement)
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Article 3 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 3 - Finalités du traitement
          </h2>
          <p className="mb-3 text-gray-700 dark:text-gray-300">Vos données sont utilisées pour :</p>
          <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700 dark:text-gray-300">
            <li>Fournir et améliorer nos services</li>
            <li>Personnaliser les réponses selon votre profil médical</li>
            <li>Gérer votre compte et votre authentification</li>
            <li>Appliquer les quotas d'utilisation</li>
            <li>Analyser l'usage et améliorer la plateforme</li>
            <li>Communiquer avec vous (notifications, support)</li>
            <li>Respecter nos obligations légales</li>
          </ul>
        </section>

        {/* Article 4 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 4 - Base légale du traitement
          </h2>
          <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700 dark:text-gray-300">
            <li>Exécution du contrat (CGU acceptées)</li>
            <li>Consentement explicite (profil médical, géolocalisation)</li>
            <li>Intérêt légitime (amélioration service, sécurité)</li>
            <li>Obligations légales</li>
          </ul>
        </section>

        {/* Article 5 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 5 - Durée de conservation
          </h2>
          <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700 dark:text-gray-300">
            <li>
              <strong>Données de compte :</strong> Durée du compte + 3 ans après suppression
            </li>
            <li>
              <strong>Historique conversations IA :</strong> 2 ans maximum, avec chiffrement
              AES-256-GCM et suppression automatique à expiration
            </li>
            <li>
              <strong>Posts forum :</strong> Tant que compte actif (anonymisés après suppression)
            </li>
            <li>
              <strong>Logs techniques :</strong> 12 mois
            </li>
          </ul>
        </section>

        {/* Article 6 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 6 - Partage des données
          </h2>
          <p className="mb-3 font-semibold text-gray-700 dark:text-gray-300">
            Vos données peuvent être partagées avec :
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4 mb-4 text-gray-700 dark:text-gray-300">
            <li>Firebase / Google Cloud (hébergement application et données)</li>
            <li>
              OpenAI, L.L.C. (États-Unis) : vos messages, votre profil santé et les images
              d&apos;analyses que vous soumettez lui sont transmis pour générer les réponses de
              l&apos;assistant IA. Chaque requête est envoyée avec le paramètre{' '}
              <code className="px-1 bg-gray-100 dark:bg-gray-700 rounded">store=false</code> :
              OpenAI ne conserve pas ces échanges dans l&apos;historique de notre compte et ne les
              utilise pas pour entraîner ses modèles. Ils peuvent faire l&apos;objet d&apos;une
              conservation temporaire de 30 jours maximum par OpenAI à des fins de détection
              d&apos;abus, puis sont supprimés.
            </li>

            <li>Services de paiement (si abonnement premium)</li>
          </ul>
          <div className="bg-green-50 dark:bg-green-900/20 border-l-4 border-green-500 p-4">
            <p className="font-bold text-gray-900 dark:text-white">
              Aucune donnée de santé n'est vendue à des tiers.
            </p>
          </div>
        </section>

        {/* Article 7 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 7 - Transferts hors UE
          </h2>
          <p className="leading-relaxed text-gray-700 dark:text-gray-300">
            Certains prestataires (OpenAI) sont situés aux États-Unis. Les transferts sont encadrés
            par un accord de sous-traitance (DPA) au sens de l&apos;article 28 du RGPD, par les Clauses
            Contractuelles Types de la Commission Européenne et par le Data Privacy Framework
            UE-USA.
          </p>
        </section>

        {/* Article 8 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 8 - Sécurité des données
          </h2>
          <p className="mb-3 text-gray-700 dark:text-gray-300">Mesures de sécurité :</p>
          <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700 dark:text-gray-300">
            <li>Chiffrement SSL/TLS des communications</li>
            <li>Authentification sécurisée via Google OAuth 2.0</li>
            <li>Règles de sécurité Firestore strictes</li>
            <li>
              Chiffrement AES-256-GCM des données médicales sensibles (conversations, profil santé,
              analyses)
            </li>
            <li>Clés de chiffrement individuelles par utilisateur</li>
            <li>Logs d'accès traçables (qui, quand, quoi)</li>
            <li>Sauvegardes régulières</li>
            <li>Accès limité aux données (principe du moindre privilège)</li>
            <li>Paiements sécurisés via Stripe (certifié PCI DSS)</li>
          </ul>
        </section>

        {/* Article 9 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 9 - Vos droits (RGPD)
          </h2>
          <p className="mb-4 text-gray-700 dark:text-gray-300">
            Conformément au RGPD, vous disposez des droits suivants :
          </p>

          <div className="space-y-3 text-gray-700 dark:text-gray-300">
            <div className="border-l-4 border-blue-500 pl-4">
              <p className="font-semibold">Droit d'accès</p>
              <p>Obtenir une copie de vos données</p>
            </div>

            <div className="border-l-4 border-blue-500 pl-4">
              <p className="font-semibold">Droit de rectification</p>
              <p>Corriger des données inexactes</p>
            </div>

            <div className="border-l-4 border-blue-500 pl-4">
              <p className="font-semibold">Droit à l'effacement</p>
              <p>Supprimer vos données (sauf obligations légales)</p>
            </div>

            <div className="border-l-4 border-blue-500 pl-4">
              <p className="font-semibold">Droit à la portabilité</p>
              <p>Récupérer vos données dans un format structuré</p>
            </div>

            <div className="border-l-4 border-blue-500 pl-4">
              <p className="font-semibold">Droit d'opposition</p>
              <p>Vous opposer à certains traitements</p>
            </div>

            <div className="border-l-4 border-blue-500 pl-4">
              <p className="font-semibold">Droit de limitation</p>
              <p>Limiter le traitement de vos données</p>
            </div>

            <div className="border-l-4 border-blue-500 pl-4">
              <p className="font-semibold">Droit de retirer votre consentement</p>
              <p>À tout moment pour les traitements basés sur le consentement</p>
            </div>
          </div>

          <div className="mt-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded">
            <p className="text-gray-700 dark:text-gray-300">
              <strong>Pour exercer vos droits, contactez :</strong> dpo@remadia.com
            </p>
            <p className="mt-2 text-gray-700 dark:text-gray-300">
              Vous pouvez également déposer une réclamation auprès de la CNIL :
              <a
                href="https://www.cnil.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 dark:text-blue-400 underline ml-1"
              >
                www.cnil.fr
              </a>
            </p>
          </div>
        </section>

        {/* Article 10 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 10 - Cookies
          </h2>
          <p className="mb-3 text-gray-700 dark:text-gray-300">
            Le site utilise des cookies pour :
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4 mb-4 text-gray-700 dark:text-gray-300">
            <li>Fonctionnement technique (session, authentification)</li>
            <li>Statistiques anonymisées (avec consentement)</li>
          </ul>
          <p className="text-gray-700 dark:text-gray-300">
            Vous pouvez gérer vos préférences cookies via le bandeau dédié. Pour plus
            d'informations, consultez notre{' '}
            <Link to="/legal/cookies" className="text-blue-600 dark:text-blue-400 underline">
              Politique de cookies
            </Link>
            .
          </p>
        </section>

        {/* Article 11 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 11 - Données de santé
          </h2>
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border-l-4 border-yellow-400 p-4">
            <p className="font-bold mb-2 text-gray-900 dark:text-white">Attention</p>
            <p className="text-gray-700 dark:text-gray-300">
              Les conversations avec le chatbot IA peuvent contenir des données de santé sensibles
              (article 9 RGPD).
              <strong> Ces données sont :</strong>
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4 mt-2 text-gray-700 dark:text-gray-300">
              <li>Chiffrées avec AES-256-GCM côté serveur</li>
              <li>Stockées avec clé individuelle par utilisateur</li>
              <li>Conservées maximum 2 ans puis automatiquement supprimées</li>
              <li>
                Transmises à OpenAI uniquement pour générer la réponse de l&apos;assistant, avec le
                paramètre <code className="px-1 bg-gray-100 dark:bg-gray-700 rounded">store=false</code>{' '}
                (ni conservation durable, ni entraînement des modèles)
              </li>
              <li>Jamais partagées avec des tiers commerciaux</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
